import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    title: 'Swype API Docs',
    loadComponent: () =>
      import('./pages/developer-portal/developer-portal.component').then(
        (module) => module.DeveloperPortalComponent
      )
  },
  {
    path: 'api',
    title: 'Swype API Reference',
    loadComponent: () =>
      import('./pages/api-reference/api-reference.component').then(
        (module) => module.ApiReferenceComponent
      )
  },
  {
    path: 'api/:operationId',
    title: 'Swype API Endpoint Reference',
    loadComponent: () =>
      import('./pages/api-reference/api-reference.component').then(
        (module) => module.ApiReferenceComponent
      )
  },
  {
    path: 'workflows',
    title: 'Swype Workflow Runbooks',
    loadComponent: () =>
      import('./pages/integration-workflows/integration-workflows.component').then(
        (module) => module.IntegrationWorkflowsComponent
      )
  },
  {
    path: 'workflows/:workflowId',
    title: 'Swype Workflow Runbook',
    loadComponent: () =>
      import('./pages/integration-workflows/integration-workflows.component').then(
        (module) => module.IntegrationWorkflowsComponent
      )
  },
  {
    path: 'ai',
    title: 'Swype Docs AI',
    loadComponent: () =>
      import('./pages/docs-ai/docs-ai.component').then((module) => module.DocsAiComponent)
  },
  {
    path: 'errors',
    title: 'Swype API Error Explorer',
    loadComponent: () =>
      import('./pages/error-explorer/error-explorer.component').then(
        (module) => module.ErrorExplorerComponent
      )
  },
  {
    path: 'errors/:code',
    title: 'Swype API Error Details',
    loadComponent: () =>
      import('./pages/error-explorer/error-explorer.component').then(
        (module) => module.ErrorExplorerComponent
      )
  },
  {
    path: 'quickstart',
    title: 'Swype Quickstart',
    loadComponent: () =>
      import('./pages/docs-surface/docs-surface.component').then(
        (module) => module.DocsSurfaceComponent
      )
  },
  {
    path: 'sdks',
    title: 'Swype SDKs',
    loadComponent: () =>
      import('./pages/sdk-docs/sdk-docs.component').then((module) => module.SdkDocsComponent)
  },
  {
    path: 'tools',
    title: 'Swype Developer Tools',
    loadComponent: () =>
      import('./pages/tools-docs/tools-docs.component').then((module) => module.ToolsDocsComponent)
  },
  {
    path: 'webhooks',
    title: 'Swype Webhooks',
    loadComponent: () =>
      import('./pages/webhook-docs/webhook-docs.component').then(
        (module) => module.WebhookDocsComponent
      )
  },
  {
    path: '**',
    redirectTo: ''
  }
];
